import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../../supabase/supabaseClient';

/**
 * Registra una visita en la tabla `page_views` de Supabase cada vez
 * que cambia la ruta. Se usa para alimentar el grafico de trafico
 * (diario / semanal / mensual) del panel de administracion.
 *
 * @param {boolean} enabled - si es false, no registra nada (p.ej. en rutas /admin)
 */
export function usePageTracking(enabled = true) {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (!enabled) return;
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;

    supabase
      .from('page_views')
      .insert({
        path: location.pathname,
        referrer: document.referrer || null,
      })
      .then(({ error }) => {
        if (error && import.meta.env.DEV) {
          console.warn('No se pudo registrar la visita:', error.message);
        }
      });
  }, [location.pathname, enabled]);
}
